export default "__VITE_ASSET__BOR7V3E2__"